import React from "react";

export default function SelectBox({ value, onChange, options, testid, placeholder }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full h-10 px-3 border border-border rounded-md bg-card text-sm"
      data-testid={testid}
    >
      <option value="">{placeholder}</option>
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
